import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="main-footer" className="bg-slate-900">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-12">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1 space-y-5">
            <div className="flex items-center gap-3">
              <img
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-10 sm:h-14 w-auto brightness-0 invert flex-shrink-0"
              />
              <span className="font-oswald font-bold text-base sm:text-xl text-white tracking-wide uppercase leading-tight">
                SYNERGYTUFF INDIA PRIVATE LIMITED
              </span>
            </div>
            <p className="font-roboto text-slate-400 text-sm leading-relaxed">
              {companyInfo.experience} of excellence in toughened glass manufacturing.
              Premium architectural and safety glass solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-rajdhani text-white font-semibold text-lg mb-5 sm:mb-6">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { label: 'Home', path: '/' },
                { label: 'About Us', path: '/about' },
                { label: 'Products', path: '/products' },
                { label: 'Applications', path: '/applications' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="font-roboto text-slate-400 hover:text-brand-light transition-colors text-sm"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h3 className="font-rajdhani text-white font-semibold text-lg mb-5 sm:mb-6">Explore</h3>
            <ul className="space-y-3">
              {[
                { label: 'Gallery', path: '/gallery' },
                { label: 'Contact Us', path: '/contact' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.path}
                    className="font-roboto text-slate-400 hover:text-brand-light transition-colors text-sm"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-rajdhani text-white font-semibold text-lg mb-5 sm:mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={16} className="text-brand-light flex-shrink-0 mt-1" />
                <a href={`tel:${companyInfo.phone}`} className="font-roboto text-slate-400 hover:text-brand-light transition-colors text-sm">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail size={16} className="text-brand-light flex-shrink-0 mt-1" />
                <a href={`mailto:${companyInfo.email}`} className="font-roboto text-slate-400 hover:text-brand-light transition-colors text-sm break-all">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-brand-light flex-shrink-0 mt-1" />
                <span className="font-roboto text-slate-400 text-sm leading-relaxed">
                  {companyInfo.address}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5">
          <p className="font-roboto text-xs sm:text-sm text-slate-500 text-center">
            &copy; {currentYear} SynergyTuff India Private Limited. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
